/**
 * Created by daniel on 23/04/17.
 */
import * as _ from "lodash";
let cleanse = (item) => item === undefined ? undefined : JSON.parse(JSON.stringify(item));

/**
 * Get the full content item for this ID
 * @param {string} state
 * @param {string} contentId
 * @returns {ContentDefinition}
 */
export const getContentItem = (state, contentId) => {
  let content = cleanse(_.head(_.filter(state.editor.content.present,{contentId})));
  if (!content) return undefined;
  let contentDef = cleanse(_.head(_.filter(state.editor.config.contentDefinitions,{configId: content.configId})));
  return {...contentDef, ...content};
};

//TODO refactor other getters to use this function
/**
 * Return all content items matching the given predicate
 * @param {string} state
 * @param {Object} predicate - A subset of a content definition to match
 * @returns {Array.<ContentDefinition>}
 */
export const getContentItems = (state, predicate) => {
  
  // Set sortorders
  let content = cleanse(state.editor.content.present);
  
  let sortIndex = 0;
  function setSortIndex(item) {
    item.sortIndex = sortIndex;
    sortIndex++;
    let children = _.filter(content, {contentParentId: item.contentId});
    
    //if (children.length > 0) {
      children.map(setSortIndex)
    //}
  }
  
  _.filter(content, {contentIsRoot: true}).map(setSortIndex);
  
  let contentArray = _.sortBy(_.filter(content, predicate), ['sortIndex']);
  
  return contentArray ? contentArray.map((child) => getContentItem(state, child.contentId)) : [];
};

/**
 * Get the full child content item(s) for this ID
 * @param state
 * @param contentId
 * @returns {Array.<ContentDefinition>}
 */
export const getContentItemChildren = (state, contentId) => {
  let childArray = cleanse(_.filter(state.editor.content.present,{contentParentId: contentId}));
  return childArray ? childArray.map((child) => getContentItem(state, child.contentId)) : [];
};

/**
 * Get the template root node
 * @param state
 * @returns {ContentDefinition}
 */
export const getRootItem = (state) => {
  let root = cleanse(_.head(_.filter(state.editor.content.present,{contentIsRoot: true})));
  return root ? getContentItem(state, root.contentId) : undefined;
};

/**
 * Determines whether any of a content items ancestors are hidden
 * @param state
 * @param contentId
 * @return {boolean}
 */
export const hasHiddenAncestor = (state, contentId) => {
  let item = getContentItem(state, contentId);
  if (!item.contentParentId) return false;
  
  let itemParent = getContentItem(state, item.contentParentId);
  if (itemParent.contentHidden) {
    return true;
  } else {
    return hasHiddenAncestor(state, itemParent.contentId)
  }
};

/**
 * Get the current state of the editor - typically used for saving as template / email
 * @param state
 * @returns {Array}
 */
export const getContentState = (state) => state.editor.content.present;


// WEBPACK FOOTER //
// ./src/App/Editor/state/content/selectors.js